import * as React from "react";

interface IProps {
    dashNumber: number;
}

export const generateVerticalDash = (dashNumber: number) => {
    const style = {
        width: 2,
        backgroundColor: "#F58220",
        height: 6,
        marginBottom: 6,
        marginTop: 6,
    };
    return Array.from(Array(dashNumber), (_, i) => i + 1).map((curNumber, indx) => {
        return(
            <div style={style} key={indx}/>
        );
    });
};

export const VerticalDashLine = (props: IProps) => {

    return (
        <div>
            {generateVerticalDash(props.dashNumber)}
        </div>
    );
};

export default VerticalDashLine;
